import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import { useGameStore } from "./game/useGameStore";
import { bindTelemetry } from "./telemetry/bind";
import { isFirstLaunch, track } from "./telemetry/telemetry";

// Debug handle for remote DevTools (adb forward → chrome_devtools_remote):
// the installed Quest TWA has no visible console, so on-device flow debugging
// reads game state through this instead of guessing from logcat.
(window as unknown as { __sq?: typeof useGameStore }).__sq = useGameStore;

function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || !window.isSecureContext) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("service-worker.js").catch((error) => {
      console.warn("Samurai Quest service worker registration failed.", error);
    });
  });
}

function initTelemetry() {
  // bindTelemetry() derives every gameplay event from store phase
  // transitions — see src/telemetry/bind.ts. track("app_launch", …) also
  // drains any events left in the persisted offline queue from a previous
  // launch, since flush() always sends the whole queue, not just the new
  // event.
  bindTelemetry();
  track("app_launch", { first_launch: isFirstLaunch });

  window.addEventListener("error", (event) => {
    track("error", {
      message: String(event.message ?? "").slice(0, 300),
      stack_head:
        event.error?.stack?.split("\n").slice(0, 3).join("\n") ?? null,
      fatal: false,
    });
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    track("error", {
      message: String(reason?.message ?? reason ?? "unhandled rejection").slice(
        0,
        300,
      ),
      stack_head: reason?.stack?.split("\n").slice(0, 3).join("\n") ?? null,
      fatal: false,
    });
  });
}

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

registerServiceWorker();
initTelemetry();
ReactDOM.createRoot(root).render(<App />);
